/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/

const projectConfigLoader = require('@root/config');
import plonevoltoSlate from '@plone/volto-slate';
import voltoItagPlone from 'volto-itag-plone';
import voltoUserProjects from 'volto-user-projects';

const addonsInfo = [{"name":"@plone/volto-slate","version":"18.5.1","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/opt/itag/plone/itag-plone/frontend/core/packages/volto-slate/src","packageJson":"/opt/itag/plone/itag-plone/frontend/core/packages/volto-slate/package.json","basePath":"/opt/itag/plone/itag-plone/frontend/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"volto-itag-plone","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/itag/plone/itag-plone/frontend/packages/volto-itag-plone/src","packageJson":"/opt/itag/plone/itag-plone/frontend/packages/volto-itag-plone/package.json","basePath":"/opt/itag/plone/itag-plone/frontend/packages/volto-itag-plone","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"volto-itag-plone/*":["./src/*"]}],"addons":[]},{"name":"volto-user-projects","version":"0.1.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/itag/plone/itag-plone/frontend/packages/volto-user-project/src","packageJson":"/opt/itag/plone/itag-plone/frontend/packages/volto-user-project/package.json","basePath":"/opt/itag/plone/itag-plone/frontend/packages/volto-user-project","tsConfigPaths":null,"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}


const projectConfig = (config) => {
  return projectConfigLoader && typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, voltoItagPlone, voltoUserProjects];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
